import React                          from "react";
import bnc                            from "bnc";
import {GrowGap, HBox, LGap, SGap}    from "@sirius/ui-lib/src/blocks/Layout";
import {Icon}                         from "@sirius/ui-lib/src/blocks/Controls";
import colors                         from "@sirius/ui-lib/src/styles/values/colors.json";
import {SheduleLinkCompact}           from "Cheops/containers/SheduleLinkCard";
import {DEPLOY_NAME}                  from "CheopsRoot/clusters/dnt";
import                                     "./index.less";

const block = new bnc("platform-landing-title");

const AiIcon = ({className}: {className: string}) =>
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5996 8.21885L15.7559 7.0001V5.1251C15.7559 4.96885 15.6621 4.8126 15.5371 4.71885L11.8184 2.2501C11.6934 2.15635 11.5059 2.15635 11.3496 2.21885L9.84961 2.9376L8.34961 2.21885C8.19336 2.15635 8.03711 2.15635 7.88086 2.2501L4.16211 4.71885C4.03711 4.8126 3.97461 4.96885 3.97461 5.1251V7.0001L2.13086 8.21885C2.00586 8.28135 1.91211 8.4376 1.91211 8.59385V12.7501C1.91211 12.9376 2.00586 13.0939 2.16211 13.1564L3.97461 14.0939V15.6251C3.97461 15.8126 4.06836 15.9689 4.22461 16.0314L7.94336 18.0001C8.00586 18.0314 8.09961 18.0626 8.16211 18.0626C8.22461 18.0626 8.28711 18.0626 8.34961 18.0314L9.84961 17.3126L11.3496 18.0314C11.4121 18.0626 11.4746 18.0626 11.5371 18.0626C11.5996 18.0626 11.6934 18.0314 11.7559 18.0001L15.4746 16.0314C15.6309 15.9376 15.7246 15.7814 15.7246 15.6251V14.1251L17.5371 13.1876C17.6934 13.0939 17.7871 12.9376 17.7871 12.7814V8.59385C17.8184 8.4376 17.7246 8.28135 17.5996 8.21885ZM16.8809 12.4689L15.2871 13.3126L14.4746 12.9376C14.2559 12.8126 13.9746 12.9376 13.8496 13.1564C13.7246 13.3751 13.8496 13.6564 14.0684 13.7814L14.8184 14.1251V15.3439L11.5371 17.0626L10.0684 16.3439H10.0371C10.0059 16.3439 10.0059 16.3439 9.97461 16.3126H9.94336H9.91211H9.88086H9.84961H9.81836H9.78711C9.78711 16.3126 9.75586 16.3126 9.75586 16.3439H9.72461L8.16211 17.0939L4.91211 15.3439V14.1251L5.66211 13.7814C5.88086 13.6564 6.00586 13.3751 5.88086 13.1564C5.75586 12.9376 5.47461 12.8126 5.25586 12.9376L4.44336 13.3126L2.84961 12.4689V8.84385L4.44336 7.8126L5.25586 8.1876C5.47461 8.3126 5.75586 8.1876 5.88086 7.96885C6.00586 7.7501 5.88086 7.46885 5.66211 7.34385L4.91211 7.0001V5.40635L8.22461 3.21885L9.38086 3.7501V12.6876C9.38086 12.9376 9.59961 13.1564 9.84961 13.1564C10.0996 13.1564 10.3184 12.9376 10.3184 12.6876V3.7501L11.5059 3.1876L14.8184 5.3751V6.96885L14.0684 7.3126C13.8496 7.4376 13.7246 7.71885 13.8496 7.9376C13.9746 8.15635 14.2559 8.28135 14.4746 8.15635L15.2871 7.78135L16.8809 8.84385V12.4689ZM13.6621 8.9376L12.4433 8.15635V5.59385C12.4433 5.34385 12.2246 5.1251 11.9746 5.1251C11.7246 5.1251 11.5058 5.34385 11.5058 5.59385V8.40635C11.5058 8.5626 11.5996 8.71885 11.7246 8.8126L12.9433 9.59385V11.4064L11.7558 12.0314C11.5996 12.1251 11.5058 12.2814 11.5058 12.4376V14.3126C11.5058 14.5626 11.7246 14.7814 11.9746 14.7814C12.2246 14.7814 12.4433 14.5626 12.4433 14.3126V12.7189L13.6308 12.0939C13.7871 12.0001 13.8808 11.8439 13.8808 11.6876V9.3126C13.8808 9.1876 13.7871 9.03135 13.6621 8.9376ZM7.28714 5.59385C7.28714 5.34385 7.50589 5.1251 7.75589 5.1251C8.00589 5.1251 8.22464 5.34385 8.22464 5.6251V8.4376C8.22464 8.59385 8.13089 8.7501 8.00589 8.84385L6.78714 9.6251V11.4376L7.97464 12.0626C8.13089 12.1251 8.22464 12.2814 8.22464 12.4689V14.3439C8.22464 14.5939 8.00589 14.8126 7.75589 14.8126C7.50589 14.8126 7.28714 14.5939 7.28714 14.3439V12.7501L6.09964 12.1251C5.94339 12.0626 5.84964 11.9064 5.84964 11.7189V9.34385C5.84964 9.1876 5.94339 9.03135 6.06839 8.9376L7.28714 8.15635V5.59385Z" fill="white"/>
    </svg>
;

type AdditionalHeaderLinkType = {
    text:     string;
    link:     string;
    short?:   boolean;
    bgColor?: string;
    icon?:    string |  React.ComponentType<{className: string}>;
};

const AdditionalHeaderLink = ({text, link, short = true, bgColor = colors["color-primary-button"], icon = AiIcon}: AdditionalHeaderLinkType) =>

    <a  href      = {link}
        target    = "_blank"
        rel       = "noopener noreferrer"
        className = { block.el('additional-button') +
                      block.el('additional-button').bod('short', short)
        }
        style     = {{backgroundColor: bgColor}}
    >

        <HBox className={block.el('additional-button').mod('icon')}>
            <Icon icon = {icon}/>
            <SGap/>
        </HBox>
        <span className = {block.el('additional-button').mod('text')}>
            {text}
        </span>
    </a>
;

const PlatformLandingTitle : React.FC = ({children}) =>
    <HBox className={block}>
        <span className={block.el('text')}>
            {children}
        </span>
        <GrowGap/>
        {
            CONFIG.DeployName === DEPLOY_NAME.SIRIUS &&
            <HBox className={block.el('buttons')}>
                <AdditionalHeaderLink text = {'Курсы по искусственному интеллекту'}
                                      link = {'/ai-navigator?bannerId=APrlpN'}
                />
                <SGap/>
                <LGap/>
                <SheduleLinkCompact/>
            </HBox>
        }
    </HBox>
;

export {PlatformLandingTitle, AdditionalHeaderLink};
